import { APP_BASE_PATH } from '../../../common/constants'

const TITLE = 'Partner With the Leader in Debt Resolution | Freedom Debt Relief'
const URL = `${APP_BASE_PATH()}/partner-with-the-leader-in-debt-resolution/`
const DESCRIPTION =
  'We are here to help! Please contact us by phone at 1-800-544-7211 or via email, click here now to get a hold of us.'

const SEO = {
  title: TITLE,
  description: DESCRIPTION,
  canonical: URL,
  openGraph: {
    title: TITLE,
    description: DESCRIPTION,
    url: URL,
    type: 'article',
    locale: 'en_US',
    article: {
      authors: ['https://www.facebook.com/freedomdebtrelief'],
    },
    images: [
      {
        url: 'https://www.freedomdebtrelief.com/wp-content/uploads/2017/08/fdr_sales_sheet_partner.webp',
      },
    ],
  },
}

export default SEO
